import { Dispatch } from "redux";
import TemperatureApi from "../api/TemperatureApi";
import { Collection } from "../Model/Collection";
import { ETemperatureState } from "../Model/ETemperatureState";
import {
  ModuleTemperatureChange, ModuleTemperatureSensorCollection, TemperatureSensor
} from "../Model/Temperature";
import {
  fetchTemperatureError,
  fetchTemperaturePending,
  fetchTemperatureSuccess, updateTemperatureReading
} from "../redux/actions/TemperatureActions";
import DateUtil from "../Utility/DateUtil";

function getTemperatureSensorCollection(temperatureSensors: TemperatureSensor[]): Collection<TemperatureSensor> {
  let allIds = [];
  let byId: { [index: string]: TemperatureSensor } = {};
  for (let temperatureSensor of temperatureSensors) {
    allIds.push(temperatureSensor.name);
    byId[temperatureSensor.name] = temperatureSensor;
  }
  return {
    allIds: allIds,
    byId: byId,
  };
}

export function fetchTemperatureSensors() {
  return (dispatch: Dispatch) => {
    dispatch(fetchTemperaturePending());
    TemperatureApi.getTemperatureSensors()
      .then((moduleTemperatureSensors) => {
        let moduleTemperatureSensorCollection: ModuleTemperatureSensorCollection = {
          allIds: [],
          byId: {},
        };

        for (let moduleTemperatureSensor of moduleTemperatureSensors) {
          moduleTemperatureSensorCollection.allIds.push(moduleTemperatureSensor.identifier);
          const temperatureSensor = {
            ...moduleTemperatureSensor,
            temperatureSensorCollection: getTemperatureSensorCollection(moduleTemperatureSensor.temperatureSensors),
          };
          moduleTemperatureSensorCollection.byId[moduleTemperatureSensor.identifier] = temperatureSensor;
        }
        dispatch(fetchTemperatureSuccess(moduleTemperatureSensorCollection));
        const moduleTemperatureReadings: ModuleTemperatureChange[] = moduleTemperatureSensors.map(
          (moduleTemperatureSensor) => ({
            identifier: moduleTemperatureSensor.identifier,
            time: DateUtil.toString(new Date()),
            data: moduleTemperatureSensor.temperatureReading,
            state: ETemperatureState.Steady,
          })
        );
        dispatch(updateTemperatureReading(moduleTemperatureReadings));
      })
      .catch((error) => {
        dispatch(fetchTemperatureError(error));
      });
  };
}
